import React, { Component, Fragment, useState } from "react";
import { Button, Input } from "reactstrap";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import TextareaAutosize from "react-textarea-autosize";
import styles from "./index.module.scss";

import {
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Card,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { useMutation, useQuery } from "@apollo/client";
import {
  GET_ORG_PROFILE,
  GET_ORG_PROFILE_2,
  GET_TICKET_PACKAGES,
  GET_USER_PROF,
  QUERY_MY_SUPPORTER_INFO,
  UPDATE_USERINFO,
  UPDATE_USER_ICON,
  USER_CHECKOUT_TICKET,
} from "../../../../queries";
import { colors } from "@mui/material";
import { useOrgPk } from "../../../../Layout/AppMain/LoginStatusContext";

const ProfileBox = ({
  userData,
  refetch,
  allSdgs,
  allNpoQuetionnaireItems,
}) => {
  const {
    username: n,
    phoneNumber: p,
    age: a,
    sex: s,
    belongs: b,
    sdgsInterest,
    npoInterest,
    totalTicket = 0,
  } =
    // } = userData[0] && userData[0].additionalInfo && userData[0].additionalInfo;
    {
      ...userData[0].additionalInfo,
      ...userData[0],
    };
  const orgId = useOrgPk();

  const [editButton, setEditButton] = useState(false);
  const buttonToggle = () => setEditButton(!editButton);

  const [pricingModalOpen, setPricingModalOpen] = useState(false);

  const [username, setName] = useState(n);
  const [email, setEmail] = useState(userData[0].email);
  const [phoneNumber, setPhone] = useState(p);
  const [age, setAge] = useState(a);
  const [sex, setSex] = useState(s);
  const [belongs, setBelongs] = useState(b);
  const [free_write, setFreeWrite] = useState(false);
  const { data: ticketsData, loading } = useQuery(GET_TICKET_PACKAGES);
  const ticketsPlan = ticketsData?.allTicket?.edges;

  // 検証用 sdgs and NPO list
  let SDGsList = [];
  let NPOList = [];
  if (sdgsInterest?.edges) {
    for (const elm of sdgsInterest?.edges) {
      SDGsList.push(elm?.node?.id);
    }
  }

  if (npoInterest?.edges) {
    for (const elm of npoInterest?.edges) {
      NPOList.push(elm?.node?.id);
    }
  }
  const [sdgsId, setSdgsId] = useState(SDGsList);
  const [npoInterestId, setNpoInterestId] = useState(NPOList);

  // 検証用リストに追加する関数
  const addSdgsId = (id) => {
    setSdgsId([...sdgsId, id]);
  };
  const rmSDGsId = (id) => {
    let _list = [];
    for (let i of sdgsId) {
      if (i !== id) {
        _list.push(i);
      }
    }
    setSdgsId(_list);
  };
  const addNpoInterestId = (id) => {
    setNpoInterestId([...npoInterestId, id]);
  };

  const rmNpoInterestId = (id) => {
    let _list = [];
    for (let i of npoInterestId) {
      if (i !== id) {
        _list.push(i);
      }
    }
    setNpoInterestId(_list);
  };

  // 所属情報変更
  const change_belongs = (value) => {
    if (value == "input_belongs") {
      setFreeWrite(true);
      setBelongs("");
    } else {
      setFreeWrite(false);
      setBelongs(value);
    }
  };

  // 個人情報編集
  const [updateUserInfo, { data }] = useMutation(UPDATE_USERINFO, {
    refetchQueries: [{ query: GET_USER_PROF }],
  });

  const [userCheckoutTicket] = useMutation(USER_CHECKOUT_TICKET);

  const handleCheckout = async (ticketId) => {
    try {
      const res = await userCheckoutTicket({
        variables: {
          ticketId: ticketId,
        },
      });
      window.location.href = res.data.userCheckoutTicket.url;
    } catch (err) {
      alert(err.message);
    }
  };

  const updatedUserInfo = async (e) => {
    try {
      await updateUserInfo({
        variables: {
          email: email,
          username: username,
          phone: phoneNumber,
          age: age,
          sex: sex,
          belongs: belongs,
          npoInterest: npoInterestId,
          sdgsInterest: sdgsId,
        },
      });
      buttonToggle();
      refetch();
    } catch (err) {
      alert(err.message);
    }
    try {
      setFreeWrite(false);
    } catch (err) {
      console.log(err);
    }
  };

  // アイコンアップロード
  const [updateUserIcon, { iconResult, error: imageerror }] =
    useMutation(UPDATE_USER_ICON);
  const [icon, setIcon] = useState();
  const [modal, setModal] = useState(false);

  const modalToggle = () => {
    setModal(!modal);
  };

  const upload = async () => {
    try {
      await updateUserIcon({
        variables: { icon: icon, userId: userData[0].id },
      });
    } catch {
      alert(
        "画像サイズが上限を超えています、1Mbyteを超えない画像をアップしてください"
      );
    }
    setModal(!modal);
    await refetch();
  };

  const onSelectImageFile = (e) => {
    if (e.currentTarget.files !== null) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        setIcon({
          name: file.name,
          file: e.target.result,
        });
      };
      // 必須
      reader.readAsDataURL(file);
    }
  };

  const userName =
    userData[0].additionalInfo && userData[0]?.additionalInfo?.username;

  return (
    <Fragment>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <div>
          <Row>
            <Col md="12">
              <Card className="card-shadow-primary card-border mb-3 ema__flex">
                <div className="dropdown-menu-header ema__flex_basis_40 bg-secondary ema__flex_content_center">
                  <div className="dropdown-menu-header-inner">
                    <div className="menu-header-content">
                      <div className="avatar-icon-wrapper">
                        {editButton ? (
                          <div
                            className="btn-hover-shine pointer"
                            onClick={modalToggle}
                          >
                            <img
                              src={userData[0].iconUrl}
                              alt="icon"
                              className="ema__avator"
                            />
                          </div>
                        ) : (
                          <div className="btn-hover-shine">
                            <img
                              src={userData[0].iconUrl}
                              alt="icon"
                              className="ema__avator"
                            />
                          </div>
                        )}
                      </div>
                      <div>
                        {editButton ? (
                          username ? (
                            <TextareaAutosize
                              className="menu-header-title"
                              placeholder={username}
                              minRows={1}
                              maxRows={1}
                              style={{
                                width: "50%",
                                fontSize: 18,
                                paddingLeft: 7,
                                paddingTop: 2,
                                paddingBottom: 2,
                              }}
                              value={username}
                              onChange={(e) => setName(e.target.value)}
                            />
                          ) : (
                            <TextareaAutosize
                              className="menu-header-title"
                              placeholder="名前の入力"
                              minRows={1}
                              maxRows={1}
                              style={{
                                width: "50%",
                                fontSize: 18,
                                paddingLeft: 7,
                                paddingTop: 2,
                                paddingBottom: 2,
                              }}
                              value={username}
                              onChange={(e) => setName(e.target.value)}
                            />
                          )
                        ) : (
                          <div>
                            {userName === null ||
                            userName === "0" ||
                            userName.trim() === "" ? (
                              <div>
                                <h5 className="menu-header-title">
                                  名前が登録されていません
                                </h5>
                              </div>
                            ) : (
                              <h5 className="menu-header-title">
                                {userData[0].additionalInfo &&
                                  userData[0].additionalInfo?.username}
                              </h5>
                            )}
                          </div>
                        )}
                      </div>
                      {editButton ? (
                        <Button
                          size="sm"
                          color="info"
                          className="mr-2 mt-2"
                          onClick={updatedUserInfo}
                        >
                          更新
                        </Button>
                      ) : (
                        <Button
                          size="sm"
                          color="info"
                          className="mr-2 mt-2"
                          onClick={buttonToggle}
                        >
                          プロフィールの編集
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="ema__flex_basis_60">
                  <ListGroup flush>
                    <ListGroupItem>
                      <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                          <div className="widget-heading　widget-content-left">
                            メールアドレス
                          </div>
                          {editButton ? (
                            <TextareaAutosize
                              className="form-control"
                              placeholder={email}
                              minRows={1}
                              maxRows={1}
                              style={{ width: "70%" }}
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          ) : (
                            <div className="widget-heading　widget-content-right">
                              {email}
                            </div>
                          )}
                        </div>
                      </div>
                    </ListGroupItem>
                    <ListGroupItem>
                      <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                          <div className="widget-heading　widget-content-left">
                            電話番号
                          </div>
                          {editButton ? (
                            phoneNumber ? (
                              <TextareaAutosize
                                className="form-control"
                                placeholder={phoneNumber}
                                minRows={1}
                                maxRows={1}
                                style={{ width: "70%" }}
                                value={phoneNumber}
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            ) : (
                              <TextareaAutosize
                                className="form-control"
                                placeholder="電話番号の入力"
                                minRows={1}
                                maxRows={1}
                                style={{ width: "70%" }}
                                value={phoneNumber}
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            )
                          ) : (
                            <div className="widget-heading　widget-content-right">
                              {userData[0].additionalInfo &&
                                userData[0].additionalInfo.phoneNumber}
                            </div>
                          )}
                        </div>
                      </div>
                    </ListGroupItem>
                    <ListGroupItem>
                      <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                          <div className="widget-heading　widget-content-left">
                            年齢
                          </div>
                          {editButton ? (
                            <Input
                              style={{ width: "70%" }}
                              type="select"
                              onChange={(e) => {
                                setAge(e.target.value);
                              }}
                            >
                              <option value="">変更する</option>
                              <option value="1">10代</option>
                              <option value="2">20代</option>
                              <option value="3">30代</option>
                              <option value="4">40代</option>
                              <option value="5">50代</option>
                              <option value="6">60代</option>
                              <option value="7">70代</option>
                              <option value="8">80代</option>
                              <option value="9">90代</option>
                              <option value="0">無回答</option>
                            </Input>
                          ) : (
                            <div className="widget-heading　widget-content-right">
                              {userData[0].additionalInfo &&
                                userData[0].additionalInfo.age}
                            </div>
                          )}
                        </div>
                      </div>
                    </ListGroupItem>
                    <ListGroupItem>
                      <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                          <div className="widget-heading　widget-content-left">
                            性別
                          </div>
                          {editButton ? (
                            <Input
                              style={{ width: "70%" }}
                              type="select"
                              onChange={(e) => {
                                setSex(e.target.value);
                              }}
                            >
                              <option>変更する</option>
                              <option value="1">男性</option>
                              <option value="2">女性</option>
                              <option value="0">無回答</option>
                            </Input>
                          ) : (
                            <div className="widget-heading　widget-content-right">
                              {userData[0].additionalInfo &&
                                userData[0].additionalInfo.sex}
                            </div>
                          )}
                        </div>
                      </div>
                    </ListGroupItem>
                    <ListGroupItem>
                      <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                          <div className="widget-heading　widget-content-left">
                            所属
                          </div>
                          {editButton ? (
                            <Input
                              style={{ width: "70%" }}
                              type="select"
                              onChange={(e) => {
                                change_belongs(e.target.value);
                              }}
                            >
                              <option>変更する</option>
                              <option>行政・政府機関</option>
                              <option>地方自治体</option>
                              <option>国際機関</option>
                              <option>企業</option>
                              <option>助成財団</option>
                              <option>CSO（NPO/NGO）</option>
                              <option>労働組合</option>
                              <option>大学・研究機関</option>
                              <option>
                                教育関係者（大学、研究機関以外で）
                              </option>
                              <option>マスコミ・メディア</option>
                              <option>学生</option>
                              <option>フリーランス・個人事業主</option>
                              <option>特になし</option>
                              <option value="input_belongs">
                                その他（記述式）
                              </option>
                            </Input>
                          ) : (
                            <div className="widget-heading　widget-content-right">
                              {userData[0].additionalInfo &&
                                userData[0].additionalInfo.belongs}
                              <br />
                            </div>
                          )}
                        </div>
                        {free_write ? (
                          <div className="">
                            <Input
                              name="passwordrep"
                              placeholder="所属組織をご記入ください"
                              value={belongs}
                              onChange={(e) => setBelongs(e.target.value)}
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </ListGroupItem>
                    <ListGroupItem>
                      <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                          <div
                            style={{ "min-width": "150px" }}
                            className="widget-heading　widget-content-left"
                          >
                            SDGsへの関心
                          </div>
                          {editButton ? (
                            <div className="widget-heading　widget-content-right">
                              {allSdgs.edges.map((node) => {
                                if (sdgsId.includes(node.node.id)) {
                                  return (
                                    <img
                                      className="px-1 mb-2 pointer"
                                      style={{ width: "3rem" }}
                                      src={node.node.logoUrl}
                                      onClick={(e) => {
                                        rmSDGsId(node.node.id);
                                      }}
                                    />
                                  );
                                } else {
                                  return (
                                    <img
                                      className="px-1 mb-2 pointer"
                                      style={{ width: "3rem", opacity: "0.1" }}
                                      src={node.node.logoUrl}
                                      onClick={(e) => {
                                        addSdgsId(node.node.id);
                                      }}
                                    />
                                  );
                                }
                              })}
                            </div>
                          ) : (
                            <div className="widget-heading　widget-content-right">
                              {sdgsInterest?.edges?.map((node) => (
                                <img
                                  className="px-1 mb-2"
                                  style={{ width: "3rem" }}
                                  src={node.node.logoUrl}
                                />
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </ListGroupItem>
                    <ListGroupItem>
                      <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                          <div
                            style={{ "min-width": "150px" }}
                            className="widget-heading　widget-content-left"
                          >
                            CSOへの関心
                          </div>
                          {editButton ? (
                            <div>
                              {allNpoQuetionnaireItems?.edges?.map((node) => {
                                if (npoInterestId.includes(node?.node?.id)) {
                                  return (
                                    <Button
                                      className="mx-1 mb-1"
                                      onClick={(e) => {
                                        rmNpoInterestId(node?.node?.id);
                                      }}
                                    >
                                      {node?.node?.title}
                                    </Button>
                                  );
                                } else {
                                  return (
                                    <Button
                                      style={{ opacity: "0.5" }}
                                      className="mx-1 mb-1"
                                      onClick={(e) => {
                                        addNpoInterestId(node?.node?.id);
                                      }}
                                    >
                                      {node?.node?.title}
                                    </Button>
                                  );
                                }
                              })}
                            </div>
                          ) : (
                            <div className="widget-heading　widget-content-right">
                              <div className="">
                                {npoInterest?.edges?.map((node) => (
                                  <span className="mx-1">
                                    {node?.node?.title} /
                                  </span>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </ListGroupItem>
                    <ListGroupItem>
                      <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                          <div
                            style={{ "min-width": "150px" }}
                            className="widget-heading　widget-content-left"
                          >
                            チケット枚数
                          </div>
                          <div>{totalTicket}枚</div>
                        </div>
                      </div>
                    </ListGroupItem>
                    <ListGroupItem>
                      <div className="widget-content p-0">
                        <div className="widget-content-wrapper">
                          <div className="widget-heading　widget-content-left"></div>
                          <div
                            className="widget-heading　widget-content-right"
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <button
                              className="ema__btn__main csv__button"
                              style={{
                                display: "flex",
                                padding: "0 22px",
                                justifyContent: "center",
                                height: "40.3px",
                                alignItems: "center",
                                borderRadius: "999px",
                                marginBottom: "8px",
                              }}
                              onClick={() => setPricingModalOpen(true)}
                            >
                              チケット購入
                            </button>
                            <div style={{ textAlign: "right" }}>
                              <a
                                href="https://datestore.socialmap.jp/accounts/password-reset/"
                                className="ema__btn__main mb-2 csv__button"
                                target="_blank"
                              >
                                パスワードの変更はこちらへ
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ListGroupItem>
                  </ListGroup>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </CSSTransitionGroup>
      <Modal isOpen={modal} toggle={modalToggle}>
        <ModalBody className="mt-4 ml-3 mr-3">
          <p className="bold">アイコンを登録</p>
          <input type="file" onChange={onSelectImageFile} />
        </ModalBody>
        <ModalFooter style={{ background: "#fff", borderTop: "none" }}>
          <Button onClick={upload} className="main_button">
            登録
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={pricingModalOpen}
        toggle={() => setPricingModalOpen(!pricingModalOpen)}
        backdropClassName="reverted-backdrop"
        size="sm"
        contentClassName={styles["modal-content"]}
        className={styles["modal-dialog"]}
      >
        <ModalBody>
          <div
            style={{
              marginTop: "70px",
              marginBottom: "70px",
              textAlign: "center",
              fontSize: "20px",
            }}
          >
            チケット購入
          </div>
          <div
            style={{
              paddingLeft: "16px",
              paddingRight: "16px",
            }}
          >
            {ticketsPlan?.map((ticket, idx) => {
              return (
                <div
                  key={ticket?.node?.id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px 0",
                    borderBottom: "1px solid #E0E0E0",
                    borderTop: "1px solid #E0E0E0",
                    marginBottom: idx === ticketsPlan.length - 1 ? "70px" : "0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "20px",
                      gap: "16px",
                    }}
                  >
                    <div
                      style={{
                        width: "58px",
                      }}
                    >
                      {ticket?.node?.amount}枚
                    </div>
                    <div>
                      ¥
                      {String(ticket?.node?.price).toLocaleString("ja-JP", {
                        style: "currency",
                        currency: "JPY",
                      })}
                    </div>
                  </div>
                  <button
                    style={{
                      backgroundColor: "#44CAE1",
                      color: "white",
                      borderRadius: "4px",
                      border: "none",
                      padding: "12px 24px",
                    }}
                    onClick={() => handleCheckout(ticket?.node?.id)}
                  >
                    購入
                  </button>
                </div>
              );
            })}
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default ProfileBox;
